interface PlayNoticeModalProps {
  open: boolean;
  onClose: () => void;
  title: string;
}

export default function PlayNoticeModal({ open, onClose, title }: PlayNoticeModalProps) {
  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-[100] flex items-center justify-center bg-black/60 px-4"
      onClick={onClose}
    >
      <div
        className="w-full max-w-md rounded-lg bg-background-50 p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="flex items-start gap-4">
          <span className="flex h-11 w-11 shrink-0 items-center justify-center rounded-full bg-accent-100 text-accent-600">
            <i className="ri-information-line text-2xl" />
          </span>
          <div className="flex-1">
            <h3 className="font-heading text-lg font-bold text-foreground-950">播放说明</h3>
            <p className="mt-2 text-sm leading-relaxed text-foreground-600">
              您正在查看《{title}》的播放入口。当前站点为内容演示平台，暂不提供真实视频播放接口。
              正式上线后，点击播放将跳转至合作播放平台或自有播放器继续观看。
            </p>
          </div>
        </div>
        <div className="mt-5 flex justify-end gap-3">
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-700 transition-colors hover:bg-background-100"
          >
            我知道了
          </button>
          <button
            type="button"
            onClick={onClose}
            className="cursor-pointer whitespace-nowrap rounded-md bg-primary-500 px-4 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            收藏该片
          </button>
        </div>
      </div>
    </div>
  );
}